import { UNIT_OF_MEASURE } from "./constants"

/**
 * How an adder's priced quantity is set, the same for every Proposal Kind:
 *
 * - `fixed`: no input, priced at 1 (PROJECT, and any unit not below);
 * - `typed`: the seller's integer quantity, at least 1 (FOOT, SQFT, UNIT);
 * - `derived`: no input, from the design (WATT, PANEL, ARRAY; Solar only);
 * - `price`: a variable-price adder: the seller's price, at quantity 1.
 */
export type AdderQuantityMode = `derived` | `fixed` | `price` | `typed`

const TYPED_UNITS: ReadonlySet<number> = new Set([
  UNIT_OF_MEASURE.FOOT,
  UNIT_OF_MEASURE.SQFT,
  UNIT_OF_MEASURE.UNIT,
])

const DERIVED_UNITS: ReadonlySet<number> = new Set([
  UNIT_OF_MEASURE.WATT,
  UNIT_OF_MEASURE.PANEL,
  UNIT_OF_MEASURE.ARRAY,
])

export const adderQuantityMode = (adder: {
  unit: number | null | undefined
  isVariable: boolean
}): AdderQuantityMode => {
  if (adder.isVariable) return `price`
  if (adder.unit != null && TYPED_UNITS.has(adder.unit)) return `typed`
  if (adder.unit != null && DERIVED_UNITS.has(adder.unit)) return `derived`

  return `fixed`
}
